import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbAuthModule, NbEmailPassAuthProvider } from '../@nebular/auth';
import { environment } from '../../environments/environment';

import { throwIfAlreadyLoaded } from './module-import-guard';
import { DataModule } from './data/data.module';
import { AnalyticsService } from './utils/analytics.service';

const NB_CORE_PROVIDERS = [
  ...DataModule.forRoot().providers,
  NbAuthModule.forRoot({
    providers: {
      email: {
        service: NbEmailPassAuthProvider,
        config: {
          baseEndpoint: `${environment.HOST}/adminapi/auth`,
          login: {
            endpoint: '/login',
          },
          register: {
            endpoint: '/register',
          },
          logout: {
            endpoint: '',
            redirect: {
              success: '/auth/login',
              failure: null,
            },
          },
          requestPass: {
            endpoint: '/request-pass',
          },
          resetPass: {
            endpoint: '/reset-pass',
          },
          token: {
            key: 'user',
          },
        },
      },
    },
    forms: {
      login: {
        redirectDelay: 500,
        provider: 'email',
        rememberMe: true,
        showMessages: {
          success: true,
          error: true,
        },
      },
      logout: {
        redirectDelay: 500,
        provider: 'email',
      },
      validation: {
        password: {
          required: true,
          minLength: 6,
          maxLength: 50,
        },
        email: {
          required: true,
        },
      },
    },
  }).providers,
  AnalyticsService,
];

@NgModule({
  imports: [
    CommonModule,
  ],
  exports: [
    NbAuthModule,
  ],
  declarations: [],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: CoreModule,
      providers: [
        ...NB_CORE_PROVIDERS,
      ],
    };
  }
}



// WEBPACK FOOTER //
// /srv/staging/FitRadioAdmin2/src/app/@core/core.module.ts